import { AlertType } from '@ge/models/constants';

export const DerateTemplate = {
  _id: '19d07af6-0bab-11ec-9a03-0242ac130234',
  alertType: AlertType.DERATE,
  entrypoint: 'string',
  sections: [
    {
      collapsed: false,
      hidden: false,
      metadata: {
        startTime: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: '',
              },
            ],
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: '',
              },
            ],
          },
          position: {
            col: 1,
            row: 1,
            span: 12,
          },
          type: 'dateTime',
          alertType: AlertType.DERATE,
        },
        t1_hsl: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 2,
            span: 12,
          },
          type: 'number',
        },
        t2_hsl: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 3,
            span: 12,
          },
          type: 'number',
        },
        t3_hsl: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 4,
            span: 12,
          },
          type: 'number',
        },
        t4_hsl: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 5,
            span: 12,
          },
          type: 'number',
        },
        validTo: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          position: {
            col: 1,
            row: 6,
            span: 12,
          },
          type: 'dateTime',
          alertType: AlertType.DERATE,
        },
      },
      type: 'body',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        description: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'description',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        sendNotification: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'send_notification',
    },
  ],
  operations: ['create', 'edit'],
  tenantId: 'dfsa',
};
